const tableRouter = {
  path: '/QuotationList',
  redirect: '/QuotationList/home',
  name: 'QuotationList',
  component: () => import('@/views/layout/layout.vue'),
  meta: {
    title: '报价列表',
  },
  children: [
    {
      path: 'home',
      component: () => import('@/views/QuotationList/index'),
      name: 'QuotationListHome',
      meta: {
        title: '首页',
      },
      props: true,
    },
    // {
    //   path: 'details',
    //   component: () => import('@/views/QuotationList/details'),
    //   name: 'details',
    //   meta: {
    //     title: '报价单详情',
    //   },
    //   props: true,
    // },
    {
      path: 'user/:id',
      component: () => import('@/views/QuotationList/user'),
      name: 'UserQuotationList',
      meta: {
        requiresAuth: true,
        title: '用户报价单列表',
      },
      props: true,
    },
    {
      path: 'user/:id/:objectId', // 独立路由，不是嵌套
      component: () => import('@/views/QuotationList/details'),
      name: 'userQuotationDetails',
      meta: {
        requiresAuth: true,
        title: '报价单详情',
      },
      props: true,
    },
  ],
};

export default tableRouter;
